module.exports = __webpack_public_path__ + "img/main_bg_03.png";